var _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _path6, _rect, _rect2, _path7, _rect3, _rect4, _g4, _ellipse, _g5, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShip = function SvgShip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 489,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0BE8F",
    d: "M163.765 379.837c-78.01 31.431-123.912 11.294-137.195-2.787a1 1 0 0 1-.096-.12c-5.05-7.524-8.568-23.408 17.493-27.278 26.136-3.881 93.303 7.497 123.62 13.672-1.118 6.338-2.332 12.053-3.218 15.817a1 1 0 0 1-.604.696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M170.562 336.422c0 7.711-1.392 17.931-2.975 26.902m0 0c-1.118 6.338-2.332 12.053-3.218 15.817a1 1 0 0 1-.604.696c-78.01 31.431-123.912 11.294-137.195-2.787a1 1 0 0 1-.096-.12c-5.05-7.524-8.568-23.408 17.493-27.278 26.136-3.881 93.303 7.497 123.62 13.672Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E896B",
    d: "M165.413 384.076c-57.567 23.451-91.455 8.411-101.284-2.124a1 1 0 0 1-.095-.12c-3.728-5.64-6.305-17.514 12.942-20.408 19.322-2.906 68.976 5.613 91.388 10.236a229 229 0 0 1-2.35 11.718 1.01 1.01 0 0 1-.601.698"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M170.563 351.518c0 5.773-1.029 13.426-2.199 20.142m0 0a229 229 0 0 1-2.35 11.718 1.01 1.01 0 0 1-.601.698c-57.567 23.451-91.455 8.411-101.284-2.124a1 1 0 0 1-.095-.12c-3.728-5.64-6.305-17.514 12.942-20.408 19.322-2.906 68.976 5.613 91.388 10.236Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ship_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CF8D47",
    d: "M216.427 353.298c10.183 34.275-11.424 29.203-37.357 29.203-29.501 0-44.119 4.741-42.734-16.967 1.707-26.745 19.487-37.151 30.975-40.787a38 38 0 0 1 4.715-.863c-2.311-1.838-6.656-5.738-5.547-6.625 1.387-1.11 4.993 1.386 6.934 0 1.942-1.387 4.161-4.438 7.766-2.774s2.497 3.606 6.102 2.774 6.38-.832 2.219 3.883c-3.102 3.516-4.518 3.397-4.696 3.364 12.291 2.704 26.413 11.253 31.623 28.792"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M172.026 323.884a38 38 0 0 0-4.715.863c-11.488 3.636-29.268 14.042-30.975 40.787-1.385 21.708 13.233 16.967 42.734 16.967 25.933 0 47.54 5.072 37.357-29.203-5.213-17.548-19.347-26.097-31.642-28.796m-12.759-.618c-2.311-1.838-6.656-5.738-5.547-6.625 1.387-1.11 4.993 1.386 6.934 0 1.942-1.387 4.161-4.438 7.766-2.774s2.497 3.606 6.102 2.774 6.38-.832 2.219 3.883c-3.328 3.772-4.715 3.36-4.715 3.36m-12.759-.618a39 39 0 0 1 3.883-.262m8.876.88a38 38 0 0 0-3.666-.618m0 0 2.834-5.516m-2.834 5.516a39 39 0 0 0-5.21-.262m0 0c-.832-1.012-2.496-3.257-2.496-4.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D73F3F",
    stroke: "#000",
    d: "M175.078 320.863c-4.703.588-4.446 2.298-4.161 3.051 0 0 3.328-.277 7.212-.277 4.408 0 8.321 1.109 8.321 1.109.554-2.496-4.716-4.715-11.372-3.883Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ship_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CF8D47",
    d: "M109.049 360.435c8.769 29.517-9.838 25.148-32.17 25.148-25.406 0-37.995 4.083-36.801-14.611 1.47-23.032 16.78-31.993 26.674-35.124a32.5 32.5 0 0 1 4.06-.743c-1.99-1.583-5.732-4.942-4.776-5.706 1.194-.955 4.299 1.194 5.971 0s3.583-3.822 6.688-2.388c3.105 1.433 2.15 3.105 5.255 2.388 3.105-.716 5.494-.716 1.91 3.344-2.671 3.028-3.89 2.926-4.043 2.898 10.584 2.328 22.745 9.69 27.232 24.794"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M70.813 335.105a32.5 32.5 0 0 0-4.06.743c-9.894 3.131-25.205 12.092-26.675 35.124-1.194 18.694 11.395 14.611 36.8 14.611 22.333 0 40.94 4.369 32.171-25.148-4.489-15.112-16.66-22.474-27.249-24.798m-10.987-.532c-1.99-1.583-5.733-4.942-4.778-5.706 1.195-.955 4.3 1.194 5.972 0s3.583-3.822 6.688-2.388c3.105 1.433 2.15 3.105 5.255 2.388 3.105-.716 5.494-.716 1.91 3.344-2.865 3.249-4.06 2.894-4.06 2.894m-10.987-.532a33 33 0 0 1 3.344-.226m7.643.758a33 33 0 0 0-3.157-.532m0 0 2.44-4.75m-2.44 4.75a33 33 0 0 0-4.486-.226m0 0c-.717-.871-2.15-2.805-2.15-3.569"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D73F3F",
    stroke: "#000",
    d: "M73.441 332.505c-4.05.506-3.828 1.979-3.583 2.627 0 0 2.866-.239 6.21-.239 3.796 0 7.166.956 7.166.956.478-2.15-4.06-4.061-9.793-3.344Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ship_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CF8D47",
    d: "M156.161 378.515c10.183 34.275-11.423 29.202-37.356 29.202-29.502 0-44.12 4.742-42.735-16.966 1.708-26.745 19.487-37.151 30.975-40.787a38 38 0 0 1 4.716-.863c-2.312-1.839-6.657-5.738-5.548-6.626 1.387-1.109 4.993 1.387 6.935 0 1.941-1.386 4.16-4.437 7.766-2.773s2.496 3.606 6.102 2.773 6.379-.832 2.219 3.884c-3.103 3.516-4.519 3.397-4.696 3.364 12.29 2.704 26.412 11.253 31.622 28.792"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M111.761 349.101a38 38 0 0 0-4.716.863c-11.488 3.636-29.267 14.042-30.975 40.787-1.385 21.708 13.233 16.966 42.735 16.966 25.933 0 47.539 5.073 37.356-29.202-5.213-17.549-19.346-26.097-31.641-28.796m-12.759-.618c-2.312-1.839-6.657-5.738-5.548-6.626 1.387-1.109 4.993 1.387 6.935 0 1.941-1.386 4.16-4.437 7.766-2.773s2.496 3.606 6.102 2.773 6.379-.832 2.219 3.884c-3.329 3.772-4.715 3.36-4.715 3.36m-12.759-.618a39 39 0 0 1 3.883-.262m8.876.88a38 38 0 0 0-3.667-.618m0 0 2.834-5.516m-2.834 5.516a39 39 0 0 0-5.209-.262m0 0c-.832-1.012-2.496-3.257-2.496-4.145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D73F3F",
    stroke: "#000",
    d: "M114.812 346.08c-4.702.588-4.445 2.298-4.161 3.051 0 0 3.329-.278 7.212-.278 4.408 0 8.321 1.11 8.321 1.11.554-2.496-4.715-4.715-11.372-3.883Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E0B9",
    stroke: "#000",
    d: "M26.26 313.676c7.673-92.669-6.632-189.015-15.041-227.05-.139-.626.345-1.183.986-1.183h199.272a1 1 0 0 1 .982 1.195c-17.702 89.466-16.976 187.549-14.308 227.206.051.744-.714 1.236-1.403.952-71.701-29.545-141.408-12.861-169.073-.107-.704.324-1.479-.24-1.415-1.013Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M9.95 83.8C32.08 77.4 82.8 56.955 110.06 26.081a.997.997 0 0 1 1.471-.049c14.296 14.649 52.816 45.49 99.015 57.768"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.457,
    height: 385.557,
    x: 108.383,
    y: 1,
    fill: "#4E381D",
    stroke: "#000",
    rx: 3.729
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 218.333,
    height: 3.721,
    x: 1,
    y: 81.719,
    fill: "#4E381D",
    stroke: "#000",
    rx: 1.861
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M112.111 123.108c20.53-8.215 67.527-34.416 92.897-73.985.389-.606 1.26-.641 1.676-.054 13.415 18.925 49.097 58.317 91.856 74.039"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.457,
    height: 321.994,
    x: 201.598,
    y: 14.383,
    fill: "#4E381D",
    stroke: "#000",
    rx: 3.729
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 203.733,
    height: 3.721,
    x: 102.535,
    y: 121.169,
    fill: "#4E381D",
    stroke: "#000",
    rx: 1.861
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ship_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAF7E0",
    d: "M122.613 295.181c6.951-69.043-6.037-140.738-13.768-169.426-.172-.638.316-1.235.976-1.235h182.895a1 1 0 0 1 .973 1.237c-16.133 66.7-15.525 139.703-13.097 169.563.058.722-.651 1.234-1.337 1.004-65.83-22.079-129.818-9.633-155.297-.085-.703.263-1.42-.311-1.345-1.058"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M122.613 295.181c6.951-69.043-6.037-140.738-13.768-169.426-.172-.638.316-1.235.976-1.235h182.895a1 1 0 0 1 .973 1.237c-16.133 66.7-15.525 139.703-13.097 169.563.058.722-.651 1.234-1.337 1.004-65.83-22.079-129.818-9.633-155.297-.085-.703.263-1.42-.311-1.345-1.058Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172,
    cy: 466,
    fill: "#000",
    fillOpacity: 0.2,
    rx: 117,
    ry: 18
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ship_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#97784F",
    d: "M170.757 336.135c27.596-17.346 87.763-59.536 107.662-89.525h12.622l23.76 47.188c-.17 18.453-2.194 46.858-7.594 74.972a332 332 0 0 1-3.229 14.995 272 272 0 0 1-3.394 12.789c-1.884 6.437-3.992 12.659-6.346 18.522-5.944 14.807-13.454 27.332-22.873 35.281-18.067 14.848-100.608 37.486-204.186 3.969-6.391-2.644-16.991-11.13-25.924-27.783a110 110 0 0 1-5.302-11.467 129 129 0 0 1-3.658-10.584 150 150 0 0 1-3.355-13.559 176 176 0 0 1-2.227-14.225c13.241 14.113 59.325 34.399 137.733 2.647 2.104-8.821 6.311-29.813 6.311-43.22"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M28.94 390.933a176 176 0 0 1-2.227-14.225c13.241 14.113 59.325 34.399 137.733 2.647 2.104-8.821 6.311-29.813 6.311-43.22 27.596-17.346 87.763-59.536 107.662-89.525h12.622l23.76 47.188c-.17 18.453-2.194 46.858-7.594 74.972M28.94 390.933c35.516 15.692 135.729 29.347 252.449-41.567 4.466 5.439 15.882 16.935 25.818 19.404M28.94 390.933a150 150 0 0 0 3.355 13.559m274.912-35.722a332 332 0 0 1-3.229 14.995M32.295 404.492c44.916 13.083 157.024 24.256 246.124-35.722 4.912 4.41 16.901 13.583 25.559 14.995M32.295 404.492a129 129 0 0 0 3.658 10.584m268.025-31.311a272 272 0 0 1-3.394 12.789m-264.63 18.522c38.746 13.158 141.485 26.751 242.465-24.143 1.412 2.314 7.821 6.679 22.165 5.621m-264.63 18.522a110 110 0 0 0 5.301 11.467m259.329-29.989c-1.884 6.437-3.992 12.659-6.346 18.522M41.255 426.543c8.933 16.653 19.533 25.139 25.924 27.783 103.578 33.517 186.119 10.879 204.186-3.969 9.419-7.949 16.929-20.474 22.873-35.281M41.255 426.543c23.368 11.613 102.772 25.578 233.451-11.467 3.264 1.911 11.74 4.587 19.532 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E381D",
    d: "M278.127 247.046c-20.152 29.906-79.69 71.674-107.22 88.995a.8.8 0 0 0-.255.244c-.82 1.245-1.939 4.752-.94 10.395a.95.95 0 0 0 1.437.657c27.848-16.948 86.213-56.479 106.976-85.322a.99.99 0 0 1 .81-.41h11.493a1 1 0 0 1 .891.546l21.367 41.961c.465.914 1.833.618 1.872-.407.133-3.449.211-6.685.24-9.664a1 1 0 0 0-.106-.459l-23.374-46.421a1 1 0 0 0-.893-.551h-11.47a.99.99 0 0 0-.828.436M163.959 379.551c-77.983 31.421-123.882 11.307-137.181-2.773a1 1 0 0 0-.147-.128c-2.962-2.164-3.508-5.471-3.608-8.517-.027-.825.925-1.304 1.603-.833 9.277 6.443 30.88 17.453 58.516 19.111 28.373 1.702 65.169-9.6 81.684-16.074a1.003 1.003 0 0 1 1.35 1.134 261 261 0 0 1-1.612 7.382 1.01 1.01 0 0 1-.605.698"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M278.127 247.046c-20.152 29.906-79.69 71.674-107.22 88.995a.8.8 0 0 0-.255.244c-.82 1.245-1.939 4.752-.94 10.395a.95.95 0 0 0 1.437.657c27.848-16.948 86.213-56.479 106.976-85.322a.99.99 0 0 1 .81-.41h11.493a1 1 0 0 1 .891.546l21.367 41.961c.465.914 1.833.618 1.872-.407.133-3.449.211-6.685.24-9.664a1 1 0 0 0-.106-.459l-23.374-46.421a1 1 0 0 0-.893-.551h-11.47a.99.99 0 0 0-.828.436ZM163.959 379.551c-77.983 31.421-123.882 11.307-137.181-2.773a1 1 0 0 0-.147-.128c-2.962-2.164-3.508-5.471-3.608-8.517-.027-.825.925-1.304 1.603-.833 9.277 6.443 30.88 17.453 58.516 19.111 28.373 1.702 65.169-9.6 81.684-16.074a1.003 1.003 0 0 1 1.35 1.134 261 261 0 0 1-1.612 7.382 1.01 1.01 0 0 1-.605.698Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E381D",
    stroke: "#000",
    d: "M278.047 234.697c-.02 88.868-6.257 184.149-19.073 222.906-.14.423.017.88.424 1.063 4.513 2.028 11.513-4.787 12.338-7.867 17.098-63.82 20.529-158.388 21.526-215.316a.96.96 0 0 0-.209-.616c-5.123-6.441-11.697-3.456-14.682-.895a.95.95 0 0 0-.324.725Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M277 455.848c10.802 3.173 17 6.874 17 10.826 0 11.779-55.069 21.328-123 21.328s-123-9.549-123-21.328c0-3.952 6.198-7.653 17-10.826",
    opacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M77 468c3 3 23.3 9.5 80.5 11.5",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ship_svg__a",
    width: 83.754,
    height: 69.938,
    x: 135.746,
    y: 313.501,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: -10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_32299_9910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ship_svg__b",
    width: 72.264,
    height: 60.367,
    x: 39.5,
    y: 326.094,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: -10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_32299_9910"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ship_svg__c",
    width: 101.754,
    height: 78.938,
    x: 57.48,
    y: 338.718,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -18,
    dy: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32299_9910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_32299_9910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ship_svg__d",
    width: 208.91,
    height: 174.859,
    x: 85.309,
    y: 122.02,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -23,
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32299_9910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_32299_9910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ship_svg__e",
    width: 289.262,
    height: 226.107,
    x: 26.041,
    y: 246.11,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_32299_9910"
  })))));
};
export default SvgShip;